// https://www.svgrepo.com/svg/469238/maximize-size
// https://svg2jsx.com/

export function MaximizeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      fill="#000"
      className="icon flat-line"
      data-name="Flat Line"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 9L3.29 3.29M15 9l5.71-5.71M9 15l-5.71 5.71m17.42 0L15 15"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 8V4a1 1 0 011-1h4"
        data-name="primary"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 3h4a1 1 0 011 1v4"
        data-name="primary"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 21H4a1 1 0 01-1-1v-4"
        data-name="primary"
      ></path>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 16v4a1 1 0 01-1 1h-4"
        data-name="primary"
      ></path>
    </svg>
  );
}
